const selected_colors = document.querySelectorAll('.nail-picker-selected-color');
const nail_picker_updated = document.getElementById('nail-picker-updated');    
const hidden_overlay = document.getElementById('hidden-overlay');
const close_button = document.querySelector('.nail-picker-updated-close-button');
const color_items = document.querySelectorAll('.nail-picker-color');
const nail_picker_titles = document.querySelectorAll('.nail-picker-title');
const nail_picker_titles_modal = document.querySelectorAll('.nail-picker-title-modal');

const selected_colors_modal = document.querySelectorAll('.nail-picker-selected-color-modal');

const remove_selected_colors = document.querySelectorAll('.remove-selected-color');
const remove_selected_colors_modal = document.querySelectorAll('.remove-selected-color-modal');

const product_form = document.querySelector('.main-product-form');
//const product_form = document.getElementById('custom-form-for-new-nail-picker');
const main_atc_button = document.getElementById('byteex-submit-button');
const modal_atc_button = document.querySelectorAll('.atc-button-modal');

const atc_button_text = document.getElementById('atc-button-text');
const atc_button_price = document.getElementById('atc-button-price');
const atc_button_compare_price = document.getElementById('atc-button-compare-price');
const choose_color_button_text = document.getElementById('choose-color-button-text');

const atc_button_text_modal = document.querySelectorAll('.atc-button-text-modal');
const atc_button_price_modal = document.querySelectorAll('.atc-button-price-modal');
const atc_button_compare_price_modal = document.querySelectorAll('.atc-button-compare-price-modal');
const choose_color_button_text_modal = document.querySelectorAll('.choose-color-button-text-modal');
/*const atc_button_text_modal = document.getElementById('atc-button-text-modal');
const atc_button_price_modal = document.getElementById('atc-button-price-modal');
const atc_button_compare_price_modal = document.getElementById('atc-button-compare-price-modal');
const choose_color_button_text_modal = document.getElementById('choose-color-button-text-modal');*/

const main_product_id = document.getElementById('main-product-id');

const collection_filter_titles = document.querySelectorAll('.collection-filter-title');
const collection_filter_items = document.querySelectorAll('.nail-picker-collection-filter-item');

const gift_item = document.querySelectorAll('.gift-item');
const gift_item_locked = document.querySelectorAll('.gift-item-locked');
const gift_item_modal = document.querySelectorAll('.gift-item-modal');
const gift_item_locked_modal = document.querySelectorAll('.gift-item-modal-locked');


// COLLECTION FILTER
collection_filter_items.forEach((item, index, array) => {
  item.addEventListener('click', (event) => {
    const current_element = event.currentTarget;
    const is_hidden = current_element.style.opacity === '0.4';

    if (!is_hidden) {
      item.classList.add('font-semibold');
      item.style.color = '#000000';

      array.forEach(i => {
        if (i !== item) {
          i.classList.remove('font-semibold');
          i.style.color = '#4F4F4F';
        }
      });
    }    
  });
});

// MOBILE COLORS FILTER
const mobile_color_filter_button = document.querySelector('.nail-picker-color-filter-mobile-button');
const mobile_color_filter = document.querySelector('.nail-picker-color-filter-mobile');
const mobile_color_filter_arrow = document.querySelector('.nail-picker-color-filter-mobile-arrow');

mobile_color_filter_button.addEventListener('click', () => {
  mobile_color_filter.classList.toggle('hidden');
  mobile_color_filter_arrow.classList.toggle('rotate-180');
});

// COLORS FILTER
const nail_picker_filter_items = document.querySelectorAll('.nail-picker-color-filter-item');
const nail_picker_colors = document.querySelectorAll('.nail-picker-color');
nail_picker_filter_items.forEach((item, index, array) => {
  item.addEventListener('click', (event) => {
    const filter_value = event.currentTarget.dataset.value;
    mobile_color_filter.classList.add('hidden');
    mobile_color_filter_arrow.classList.toggle('rotate-180');

    item.classList.add('font-semibold');
    item.style.color = '#000000';
    
    array.forEach(i => {
      if (i !== item) {
        i.classList.remove('font-semibold');
        i.style.color = '#4F4F4F';
      }
    });

    nail_picker_colors.forEach(color => {
      const filters = color.dataset.colorFilters.toLowerCase();

      if (filters.includes(filter_value) || filter_value === 'All') {
        color.classList.remove('hidden');
      } else {
        color.classList.add('hidden');
      }
    });

    collection_filter_titles.forEach(element => {
      const filter_name = element.dataset.filterName;
      const filter_items = element.nextElementSibling;

      const allHidden = Array.from(filter_items.children).every(
        child => window.getComputedStyle(child).display === 'none'
      );

      if (allHidden) {
        element.classList.add('hidden');
        filter_items.classList.add('hidden');

        collection_filter_items.forEach(item => {
          const item_filter_name = item.dataset.value;
          const link = item.querySelector('a');
  
          if (item_filter_name === filter_name) {
            item.style.opacity = '0.4';
            link.style.cursor = 'default';
            link.style.pointerEvents = 'none';
          }
        });
      } else {
        element.classList.remove('hidden');
        filter_items.classList.remove('hidden');

        collection_filter_items.forEach(item => {
          const item_filter_name = item.dataset.value;
          const link = item.querySelector('a');
  
          if (item_filter_name === filter_name) {
            item.style.opacity = '1';
            link.style.cursor = 'pointer';
            link.style.pointerEvents = 'auto';
          }
        });
      }

      collection_filter_items.forEach(item => {
        item.classList.remove('font-semibold');
        item.style.color = '#4F4F4F';
      });
    });
  });
});

// CLOSE NAIL PICKER WINDOW
function closeOnClickOutside(event) {
  if (nail_picker_updated && !nail_picker_updated.contains(event.target)) {
    hidden_overlay.style.display = 'none';
    nail_picker_updated.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside);
  }
}

close_button.addEventListener('click', () => {
  hidden_overlay.style.display = 'none';
  nail_picker_updated.style.display = 'none';        
  document.body.style.overflow = 'auto';
  document.removeEventListener('click', closeOnClickOutside);
});

// OPEN NAIL PICKER WINDOW
selected_colors.forEach(color => {
  color.addEventListener('click', () => {
    if (nail_picker_updated) {
      hidden_overlay.style.display = 'block';
      nail_picker_updated.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside);
      }, 100);
    }
  });
});

if (main_atc_button) {
  main_atc_button.addEventListener('click', () => {
    const button_type = main_atc_button.type;
    if (button_type === 'button') {
      hidden_overlay.style.display = 'block';
      nail_picker_updated.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside);
      }, 100);
    }
  });
}

// GET SELECTED COLORS COUNT
function getSelectedCount() {
  let count = 0;
  selected_colors.forEach(color => {
    const isSelected = color.dataset.selected;
    if (isSelected) {
      count++;
    }
  });
  return count;
}

// GET MAIN SELECTED COLORS COUNT
function getMainSelectedCount() {
  let count = 0;
  const main_selected_colors = document.querySelectorAll('.main-selected-color-modal');

  main_selected_colors.forEach(color => {
    const isSelected = color.dataset.selected;
    if (isSelected) {
      count++;
    }
  });
  return count;
}

// ADD PROPERTIES TO FORM
function addPropertiesToForm() {
  const current_properties_block = document.getElementById('nail-picker-properties-block');
  if (current_properties_block) {
    current_properties_block.remove();
  }

  const main_count = getMainSelectedCount();

  if (main_count === 3) {
    const properties_block = document.createElement('div');
    properties_block.setAttribute('id', 'nail-picker-properties-block');
    
    let serial_number = 0;
    selected_colors.forEach((color, i) => {
      const isSelected = color.dataset.selected;      

      if (isSelected) {
        serial_number++;
        const id = color.dataset.id;

        const text_tag = color.querySelector('p');
        const title = text_tag.textContent;

        const img_tag = color.querySelector('img');
        const image = img_tag.src;

        const hiddenField1 = document.createElement('input');
        hiddenField1.setAttribute('type', "hidden");
        hiddenField1.setAttribute('class', `class${serial_number}`);
        hiddenField1.setAttribute('name', `properties[_${serial_number}.]`);
        hiddenField1.setAttribute('value', image);
        properties_block.appendChild(hiddenField1);        

        const hiddenField2 = document.createElement('input');
        hiddenField2.setAttribute('type', "hidden");
        hiddenField2.setAttribute('class', `class${serial_number}`);
        hiddenField2.setAttribute('name', `properties[Colour ${serial_number}]`);
        hiddenField2.setAttribute('value', title);
        properties_block.appendChild(hiddenField2);

        const hiddenField3 = document.createElement('input');
        hiddenField3.setAttribute('type', "hidden");
        hiddenField3.setAttribute('class', `class${serial_number}`);
        hiddenField3.setAttribute('name', `properties[_id${serial_number}.]`);
        hiddenField3.setAttribute('value', id);
        properties_block.appendChild(hiddenField3);
      }
    });

    product_form.appendChild(properties_block);
  }
}

// UPDATE GIFT ITEMS
function updateGiftItems(extra_count) {
  gift_item.forEach((modal, index) => {
    if (index <= extra_count - 1) {
      modal.classList.remove('hidden');
    } else {
      modal.classList.add('hidden');
    }
  });        

  gift_item_locked.forEach((modal, index) => {
    if (index <= extra_count - 1) {
      modal.classList.add('hidden');
    } else {
      modal.classList.remove('hidden');
      modal.querySelector('span').textContent = index + 1 - extra_count;
    }
  });

  gift_item_modal.forEach((modal, index) => {
    if (index <= extra_count - 1) {
      modal.classList.remove('hidden');
    } else {
      modal.classList.add('hidden');
    }
  });        

  gift_item_locked_modal.forEach((modal, index) => {  
    if (index <= extra_count - 1) {
      modal.classList.add('hidden');
    } else {
      modal.classList.remove('hidden');
      modal.querySelector('span').textContent = index + 1 - extra_count;
    }
  });  
}

// UPDATE ATC BUTTONS PRICE AND COMPARE PRICE AND MAIN PRODUCT ID 
function updateAtcButtonAndId(count) {
  switch (count) {
    case 4:
      atc_button_price.innerHTML = variant_price_2;
      atc_button_compare_price.textContent = ((+variant_compare_price_2 + +gift_price_1) / 100).toFixed(2);

      atc_button_price_modal.forEach(button => {
        button.innerHTML = variant_price_2;
      });

      atc_button_compare_price_modal.forEach(button => {
        button.textContent = ((+variant_compare_price_2 + +gift_price_1) / 100).toFixed(2);
      });

      main_product_id.value = variant_id_2;
      product_form.dataset.variantId = variant_id_2;
      break;
    case 5:
      atc_button_price.innerHTML = variant_price_3;
      atc_button_compare_price.textContent = ((+variant_compare_price_3 + +gift_price_1 + +gift_price_2) / 100).toFixed(2);

      atc_button_price_modal.forEach(button => {
        button.innerHTML = variant_price_3;
      });

      atc_button_compare_price_modal.forEach(button => {
        button.textContent = ((+variant_compare_price_3 + +gift_price_1 + +gift_price_2) / 100).toFixed(2);
      });

      main_product_id.value = variant_id_3;
      product_form.dataset.variantId = variant_id_3;
      break;
    case 6:
      atc_button_price.innerHTML = variant_price_4;
      atc_button_compare_price.textContent = ((+variant_compare_price_4 + +gift_price_1 + +gift_price_2 + +gift_price_3) / 100).toFixed(2);
      
      atc_button_price_modal.forEach(button => {
        button.innerHTML = variant_price_4;
      });

      atc_button_compare_price_modal.forEach(button => {
        button.textContent = ((+variant_compare_price_4 + +gift_price_1 + +gift_price_2 + +gift_price_3) / 100).toFixed(2);
      });

      main_product_id.value = variant_id_4;
      product_form.dataset.variantId = variant_id_4;
      break;
    default:
      atc_button_price.innerHTML = variant_price_1;
      atc_button_compare_price.textContent = (+variant_compare_price_1 / 100).toFixed(2);

      atc_button_price_modal.forEach(button => {
        button.innerHTML = variant_price_1;
      });

      atc_button_compare_price_modal.forEach(button => {
        button.textContent = (+variant_compare_price_1 / 100).toFixed(2);
      });

      main_product_id.value = variant_id_1;
      product_form.dataset.variantId = variant_id_1;
      break;
  }
}

// ADD COLOR TO PICKER FUNCTION
function addColor(id, image, title) {
  for (const color of selected_colors) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const image_wrapper = color.firstElementChild;
      image_wrapper.classList.remove('nail-picker-color-empty-next');
      image_wrapper.classList.add('nail-picker-color-image-selected');

      const img = color.querySelector('img');
      img.src = image;

      const color_name = color.querySelector('p');
      color_name.textContent = title;
      color_name.classList.remove('hidden');

      const additional_price = color.querySelector('.additional-price');
      if (additional_price) {
        additional_price.classList.remove('hidden');
      }

      const plus_icon = color.querySelector('span');
      plus_icon.style.display = 'none';

      const remove_button = color.querySelector('.remove-selected-color');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      color.dataset.id = id;
      break;
    }
  }

  for (const color of selected_colors) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const image_wrapper = color.firstElementChild;
      image_wrapper.classList.add('nail-picker-color-empty-next');

      break;
    }
  }

  for (let i = 0; i < selected_colors_modal.length; i++) {
    const color = selected_colors_modal[i];
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const image_wrapper = color.firstElementChild;
      image_wrapper.classList.remove('nail-picker-color-empty-next');
      image_wrapper.classList.add('nail-picker-color-image-selected');

      const img = color.querySelector('img');
      img.src = image;

      const color_plus = color.querySelector('span');
      color_plus.style.display = 'none';

      const color_name = color.querySelector('p');
      color_name.textContent = title;
      color_name.classList.remove('hidden');

      const additional_price = color.querySelector('.additional-price');
      if (additional_price) {
        additional_price.classList.remove('hidden');
      }

      const remove_button = color.querySelector('.remove-selected-color-modal');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;      

      break;
    }
  }

  for (let i = 0; i < selected_colors_modal.length; i++) {
    const color = selected_colors_modal[i];
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const image_wrapper = color.firstElementChild;
      image_wrapper.classList.add('nail-picker-color-empty-next');

      break;
    }
  }

  const count = getSelectedCount();  
  const main_count = getMainSelectedCount();  
  const extra_count = count - main_count;

  updateGiftItems(extra_count);

  if (main_count === 3) {
    nail_picker_titles[0].style.display = 'none';
    if (count === 6) {
      nail_picker_titles[1].style.display = 'none';
      nail_picker_titles[2].style.display = 'block';
    } else {
      nail_picker_titles[1].style.display = 'block';
    }

    nail_picker_titles_modal[0].style.display = 'none';
    if (count === 6) {
      nail_picker_titles_modal[1].style.display = 'none';
      nail_picker_titles_modal[2].style.display = 'block';
    } else {
      nail_picker_titles_modal[1].style.display = 'block';
    }

    atc_button_text.style.display = 'flex';
    choose_color_button_text.style.display = 'none';
    main_atc_button.type = 'submit';

    atc_button_text_modal.forEach(button => {
      button.style.display = 'flex';
    });

    choose_color_button_text_modal.forEach(button => {
      button.style.display = 'none';
    });

    modal_atc_button.forEach(button => {
      button.type = 'submit';
    });

    updateAtcButtonAndId(count);
    addPropertiesToForm();
  }

  /*if (count === 3 && !current_properties_block) {
    nail_picker_titles[0].style.display = 'none';
    nail_picker_titles[1].style.display = 'block';

    atc_button_text.style.display = 'flex';
    choose_color_button_text.style.display = 'none';
    main_atc_button.type = 'submit';

    const properties_block = document.createElement('div');
    properties_block.setAttribute('id', 'nail-picker-properties-block');
    
    selected_colors.forEach((color, i) => {
      const id = color.dataset.id;

      const text_tag = color.querySelector('p');
      const title = text_tag.textContent;

      const img_tag = color.querySelector('img');
      const image = img_tag.src;

      const hiddenField1 = document.createElement('input');
      hiddenField1.setAttribute('type', "hidden");
      hiddenField1.setAttribute('class', `class${i + 1}`);
      hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
      hiddenField1.setAttribute('value', image);
      properties_block.appendChild(hiddenField1);        

      const hiddenField2 = document.createElement('input');
      hiddenField2.setAttribute('type', "hidden");
      hiddenField2.setAttribute('class', `class${i + 1}`);
      if (picker_type === 'chrome') {
        hiddenField2.setAttribute('name', `properties[Chrome ${i + 1}]`);
      } else {
        hiddenField2.setAttribute('name', `properties[Colour ${i + 1}]`);
      }
      hiddenField2.setAttribute('value', title);
      properties_block.appendChild(hiddenField2);

      const hiddenField3 = document.createElement('input');
      hiddenField3.setAttribute('type', "hidden");
      hiddenField3.setAttribute('class', `class${i + 1}`);
      hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
      hiddenField3.setAttribute('value', id);
      properties_block.appendChild(hiddenField3);
    });

    product_form.appendChild(properties_block);

    hidden_overlay.style.display = 'none';
    nail_picker_updated.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside);
  }*/
}

// ADD COLORS TO PICKER
color_items.forEach(color_item => {
  color_item.addEventListener('click', (event) => {
    if (getSelectedCount() < 6) {
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;
      const data_title = current_color.dataset.title;
      const data_image = current_color.dataset.image;
      const data_count = +current_color.dataset.count;

      const current_color_items = document.querySelectorAll(`[data-title="${data_title}"]`);
      current_color_items.forEach(item => {
        const img_wrapper = item.querySelector('.nail-picker-color-image');
        img_wrapper.classList.add('nail-picker-color-image-selected');

        const color_count = item.querySelector('.nail-picker-color-count');
        color_count.textContent = data_count + 1;
        color_count.classList.remove('hidden');
        item.dataset.count = data_count + 1; 
      });

      addColor(data_id, data_image, data_title);
    }
  });
});

// REMOVE SELECTED COLORS FROM PICKER
remove_selected_colors.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    event.stopPropagation();
    const current_color = event.currentTarget;
    const parent = current_color.parentElement;
    const item_number = i;

    const image_wrapper = parent.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected');    

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder;

    const color_name = parent.querySelector('p');
    const color_name_value = color_name.textContent;
    color_name.textContent = '';
    color_name.classList.add('hidden');

    // Remove additional price
    const additional_price = parent.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    // Update color item count badge
    const color_items = document.querySelectorAll(`[data-title="${color_name_value}"]`);
    color_items.forEach(item => {
      const color_item_count = item.querySelector('.nail-picker-color-count');
      const color_item_img = item.querySelector('.nail-picker-color-image');
      const color_item_count_value = +item.dataset.count - 1;
      color_item_count.textContent = color_item_count_value;
      item.dataset.count = color_item_count_value;

      if (color_item_count_value === 0) {
        color_item_img.classList.remove('nail-picker-color-image-selected');
        color_item_count.classList.add('hidden');
      }
    });

        

    const plus_icon = parent.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = parent.querySelector('.remove-selected-color');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');
    parent.removeAttribute('data-id');

    selected_colors_modal.forEach((color, i) => {  
      if (i === item_number) {
        const image_wrapper = color.firstElementChild;
        image_wrapper.classList.remove('nail-picker-color-image-selected');

        const img = color.querySelector('img');
        img.src = selected_color_placeholder;

        const color_name = color.querySelector('p');
        color_name.textContent = '';
        color_name.classList.add('hidden');

        // Remove additional price
        const additional_price = color.querySelector('.additional-price');
        if (additional_price) {
          additional_price.classList.add('hidden');
        }

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-modal');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
      }
    });

    const main_count = getMainSelectedCount();
    const count = getSelectedCount();
    const extra_count = count - main_count;

    // Remove gift modal if color is removed
    updateGiftItems(extra_count);

    // Update nail picker titles and atc button
    if (main_count < 3) { 
      nail_picker_titles[0].style.display = 'block';
      nail_picker_titles[1].style.display = 'none';
      nail_picker_titles[2].style.display = 'none';

      nail_picker_titles_modal[0].style.display = 'block';
      nail_picker_titles_modal[1].style.display = 'none';
      nail_picker_titles_modal[2].style.display = 'none';

      atc_button_text.style.display = 'none';
      choose_color_button_text.style.display = 'block';
      main_atc_button.type = 'button';

      atc_button_text_modal.forEach(button => {
        button.style.display = 'none';
      });

      choose_color_button_text_modal.forEach(button => {
        button.style.display = 'block';
      });

      modal_atc_button.forEach(button => {
        button.type = 'button';
      });
    }

    if (main_count === 3 && count < 6) { 
      nail_picker_titles[0].style.display = 'none';
      nail_picker_titles[1].style.display = 'block';
      nail_picker_titles[2].style.display = 'none';

      nail_picker_titles_modal[0].style.display = 'none';
      nail_picker_titles_modal[1].style.display = 'block';
      nail_picker_titles_modal[2].style.display = 'none';
    }

    updateAtcButtonAndId(count);
    addPropertiesToForm();

    for (const color of selected_colors) {
      const wrapper = color.firstElementChild;
      wrapper.classList.remove('nail-picker-color-empty-next');
    }

    for (const color of selected_colors) {
      const isSelected = color.dataset.selected;
  
      if (!isSelected) {
        const wrapper = color.firstElementChild;
        wrapper.classList.add('nail-picker-color-empty-next');
  
        break;
      }
    }

    for (const color of selected_colors_modal) {
      const wrapper = color.firstElementChild;
      wrapper.classList.remove('nail-picker-color-empty-next');
    }

    for (const color of selected_colors_modal) {
      const isSelected = color.dataset.selected;
  
      if (!isSelected) {
        const wrapper = color.firstElementChild;
        wrapper.classList.add('nail-picker-color-empty-next');
  
        break;
      }
    }
  });
});

// REMOVE SELECTED COLORS FROM PICKER MODAL
remove_selected_colors_modal.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    const current_color = event.currentTarget; 
    const parent = current_color.parentElement;
    const item_number = i;

    const image_wrapper = parent.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected');

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder;

    const color_plus = parent.querySelector('span');
    color_plus.style.display = 'block';

    // Remove color name
    const color_name = parent.querySelector('p'); 
    const color_name_value = color_name.textContent;
    color_name.textContent = '';
    color_name.classList.add('hidden');

    // Remove additional price
    const additional_price = parent.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    // Update color item count badge
    const color_items = document.querySelectorAll(`[data-title="${color_name_value}"]`);
    color_items.forEach(item => {
      const color_item_count = item.querySelector('.nail-picker-color-count');
      const color_item_img = item.querySelector('.nail-picker-color-image');
      const color_item_count_value = +item.dataset.count - 1;
      color_item_count.textContent = color_item_count_value;
      item.dataset.count = color_item_count_value;

      if (color_item_count_value === 0) {
        color_item_img.classList.remove('nail-picker-color-image-selected');
        color_item_count.classList.add('hidden');
      }
    });

    


    const remove_button = parent.querySelector('.remove-selected-color-modal');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');

    selected_colors.forEach((color, i) => {  
      if (i === item_number) {
        const image_wrapper = color.firstElementChild;
        image_wrapper.classList.remove('nail-picker-color-image-selected');

        const img = color.querySelector('img');
        img.src = selected_color_placeholder;

        const color_name = color.querySelector('p');
        color_name.textContent = '';
        color_name.classList.add('hidden');

        // Remove additional price
        const additional_price = color.querySelector('.additional-price');
        if (additional_price) {
          additional_price.classList.add('hidden');
        }

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
        color.removeAttribute('data-id');
      }
    });

    const main_count = getMainSelectedCount();
    const count = getSelectedCount();
    const extra_count = count - main_count;

    updateGiftItems(extra_count);

    // Update nail picker titles and atc button
    if (main_count < 3) { 
      nail_picker_titles[0].style.display = 'block';
      nail_picker_titles[1].style.display = 'none';
      nail_picker_titles[2].style.display = 'none';

      nail_picker_titles_modal[0].style.display = 'block';
      nail_picker_titles_modal[1].style.display = 'none';
      nail_picker_titles_modal[2].style.display = 'none';

      atc_button_text.style.display = 'none';
      choose_color_button_text.style.display = 'block';
      main_atc_button.type = 'button';

      atc_button_text_modal.forEach(button => {
        button.style.display = 'none';
      });

      choose_color_button_text_modal.forEach(button => {
        button.style.display = 'block';
      });

      modal_atc_button.forEach(button => {
        button.type = 'button';
      });
    }

    if (main_count === 3 && count < 6) { 
      nail_picker_titles[0].style.display = 'none';
      nail_picker_titles[1].style.display = 'block';
      nail_picker_titles[2].style.display = 'none';

      nail_picker_titles_modal[0].style.display = 'none';
      nail_picker_titles_modal[1].style.display = 'block';
      nail_picker_titles_modal[2].style.display = 'none';
    }

    updateAtcButtonAndId(count);
    addPropertiesToForm();

    for (const color of selected_colors_modal) {
      const wrapper = color.firstElementChild;
      wrapper.classList.remove('nail-picker-color-empty-next');
    }

    for (const color of selected_colors_modal) {
      const isSelected = color.dataset.selected;
  
      if (!isSelected) {
        const wrapper = color.firstElementChild;
        wrapper.classList.add('nail-picker-color-empty-next');
  
        break;
      }
    }

    for (const color of selected_colors) {
      const wrapper = color.firstElementChild;
      wrapper.classList.remove('nail-picker-color-empty-next');
    }

    for (const color of selected_colors) {
      const isSelected = color.dataset.selected;
  
      if (!isSelected) {
        const wrapper = color.firstElementChild;
        wrapper.classList.add('nail-picker-color-empty-next');
  
        break;
      }
    }
  });
});

// CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART
/*function clearNailPicker() {
  selected_colors.forEach((item, i) => {
    const image_wrapper = item.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected');

    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_name = item.querySelector('p');
    color_name.textContent = '';

    const additional_price = item.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    const plus_icon = item.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = item.querySelector('.remove-selected-color');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
    item.removeAttribute('data-id');
  });

  selected_colors_modal.forEach((item, i) => {
    const image_wrapper = item.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected');

    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_plus = item.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = item.querySelector('p');
    color_name.textContent = '';

    const additional_price = item.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    const remove_button = item.querySelector('.remove-selected-color-modal');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
  });

  const current_properties_block = document.getElementById('nail-picker-properties-block');

  if (current_properties_block) {
    current_properties_block.remove();
  }

  nail_picker_titles[0].style.display = 'block';
  nail_picker_titles[1].style.display = 'none';
  nail_picker_titles[2].style.display = 'none';

  nail_picker_titles_modal[0].style.display = 'block';
  nail_picker_titles_modal[1].style.display = 'none';
  nail_picker_titles_modal[2].style.display = 'none';

  for (let i = 1; i <= 3; i++) {
    const gift_modal = document.querySelectorAll(`.gift-modal-${i}`);
    gift_modal.forEach(modal => {
      modal.classList.add('hidden');
    });

    const gift_modal_locked = document.querySelectorAll(`.gift-modal-locked-${i}`); 
    gift_modal_locked.forEach(modal => {
      modal.classList.remove('hidden');
    });
  }

  color_items.forEach(item => {
    const img_wrapper = item.querySelector('.nail-picker-color-image');
    img_wrapper.classList.remove('nail-picker-color-image-selected');

    const color_count = item.querySelector('.nail-picker-color-count');
    color_count.textContent = 0;
    color_count.classList.add('hidden');
    item.dataset.count = 0; 
  });
  
  atc_button_text.style.display = 'none';
  choose_color_button_text.style.display = 'flex';
  main_atc_button.type = 'button';
  
  atc_button_text_modal.forEach(button => {
    button.style.display = 'none';
  });

  choose_color_button_text_modal.forEach(button => {
    button.style.display = 'flex';
  });

  modal_atc_button.forEach(button => {
    button.type = 'button';
  });
}*/

// CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART - working in cart drawer
window.clearNewNailPicker = function() {
  selected_colors.forEach((item, i) => {
    const image_wrapper = item.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected'); 
    image_wrapper.classList.remove('nail-picker-color-empty-next'); 
    if (i === 0) {
      image_wrapper.classList.add('nail-picker-color-empty-next');
    }

    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_name = item.querySelector('p');
    color_name.textContent = '';

    // Remove additional price
    const additional_price = item.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    const plus_icon = item.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = item.querySelector('.remove-selected-color');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
    item.removeAttribute('data-id');
  });

  selected_colors_modal.forEach((item, i) => {
    const image_wrapper = item.firstElementChild;
    image_wrapper.classList.remove('nail-picker-color-image-selected'); 
    image_wrapper.classList.remove('nail-picker-color-empty-next'); 
    if (i === 0) {
      image_wrapper.classList.add('nail-picker-color-empty-next');
    }

    const img = item.querySelector('img');
    img.src = selected_color_placeholder;

    const color_plus = item.querySelector('span');
    color_plus.style.display = 'block';

    // Remove additional price
    const additional_price = item.querySelector('.additional-price');
    if (additional_price) {
      additional_price.classList.add('hidden');
    }

    const color_name = item.querySelector('p');
    color_name.textContent = '';

    const remove_button = item.querySelector('.remove-selected-color-modal');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
  });

  updateGiftItems(0);
  addPropertiesToForm();

  nail_picker_titles[0].style.display = 'block';
  nail_picker_titles[1].style.display = 'none';
  nail_picker_titles[2].style.display = 'none';

  nail_picker_titles_modal[0].style.display = 'block';
  nail_picker_titles_modal[1].style.display = 'none';
  nail_picker_titles_modal[2].style.display = 'none';

  atc_button_text.style.display = 'none';
  choose_color_button_text.style.display = 'block';
  main_atc_button.type = 'button';

  atc_button_text_modal.forEach(button => {
    button.style.display = 'none';
  });

  choose_color_button_text_modal.forEach(button => {
    button.style.display = 'block';
  });

  modal_atc_button.forEach(button => {
    button.type = 'button';
  });

  color_items.forEach(item => {
    const img_wrapper = item.querySelector('.nail-picker-color-image');
    img_wrapper.classList.remove('nail-picker-color-image-selected');

    const color_count = item.querySelector('.nail-picker-color-count');
    color_count.textContent = 0;
    color_count.classList.add('hidden');
    item.dataset.count = 0; 
  });
}

// ADD TO CART FORM LISTENER
/*product_form.addEventListener('submit', async (event) => {
  event.preventDefault();

  const loader = product_form.querySelector('.loader');
  const atc_button_text = product_form.querySelector('#atc-button-text');

  //const stickyLoader = document.getElementById("sticky_atc_button_loader");
  //const stickyButtonText = document.getElementById("sticky_atc_button_text");

  if (atc_button_text) {
    atc_button_text.style.display = "none";
  }

  if (loader) {
    loader.style.display = "block";
  }

  const body = new FormData(product_form);

  // Add gifts to the form
  const gifts_ids = [gift_1, gift_2, gift_3];
  const gift_items = document.querySelectorAll('.gift-item');
  gift_items.forEach((item, index) => {
    const is_hidden = item.classList.contains('hidden');
    if (!is_hidden) {
      body.append(`properties[_discount_iq_gift_${index + 1}]`, gifts_ids[index]);
    }
  });

  const res = await fetch("/cart/add", {
    method: "post",
    body: body,
  })
    .then(async () => {
      await updateCartDrawer();
      onOpenDrawer();

      if (loader) {
        loader.style.display = "none";
      }

      clearNailPicker();
    })
    .catch((error) => console.error("Error adding to cart:", error));
});*/

// ADD TO CART MODAL BUTTON LISTENER
modal_atc_button.forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const button_type = event.currentTarget.type;

    if (button_type === 'submit') {
      const loader = button.querySelector('.loader');
      const atc_button_text = button.querySelector('#atc-button-text');

      if (atc_button_text) {
        atc_button_text.style.display = "none";
      }

      document.getElementById('nail_picker').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      
      main_atc_button.click();
    }  
  });
});
